var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPendingValidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 11.75H5.0625C4.1325 11.75 3.375 12.5075 3.375 13.4375V14.5625H4.5V13.4375C4.5 13.13 4.755 12.875 5.0625 12.875H8.4375C8.745 12.875 9 13.13 9 13.4375V14.5625H10.125V13.4375C10.125 12.5075 9.3675 11.75 8.4375 11.75Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.1875C7.995 11.1875 9 10.1825 9 8.9375C9 7.6925 7.995 6.6875 6.75 6.6875C5.505 6.6875 4.5 7.6925 4.5 8.9375C4.5 10.1825 5.505 11.1875 6.75 11.1875ZM6.75 7.8125C7.3725 7.8125 7.875 8.315 7.875 8.9375C7.875 9.56 7.3725 10.0625 6.75 10.0625C6.1275 10.0625 5.625 9.56 5.625 8.9375C5.625 8.315 6.1275 7.8125 6.75 7.8125Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.625V16.25H2.25V5H10.335V3.875H2.25C1.6275 3.875 1.125 4.3775 1.125 5V16.25C1.125 16.8725 1.6275 17.375 2.25 17.375H15.75C16.3725 17.375 16.875 16.8725 16.875 16.25V10.625H15.75Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 11.1875H11.25V12.3125H14.625V11.1875Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 13.4375H12.375V14.5625H14.625V13.4375Z",
    fill: "#030712"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.26 4.3175V2.375H16.875V1.625H11.535V2.375H12.15V4.3175C12.15 4.4975 12.21 4.6775 12.33 4.82L12.9 5.5175L12.3375 6.3425C12.2475 6.4775 12.195 6.6275 12.195 6.7925V8.75H11.535V9.5H16.875V8.75H16.215V6.7925C16.215 6.6275 16.17 6.4775 16.08 6.3425L15.5175 5.5175L16.0875 4.82C16.2 4.6775 16.2675 4.4975 16.2675 4.3175H16.26ZM15.51 2.375V4.0175H12.8925V2.375H15.51ZM12.9375 8.75V6.77L13.8225 5.48L13.2525 4.7675H15.1575L14.58 5.48L15.4725 6.7925V8.75H12.9375Z",
    fill: "#030712"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4675 6.3875H13.935V6.935H14.4675V6.3875Z",
    fill: "#030712"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4675 7.4825H13.935V8.03H14.4675V7.4825Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendingValidation);
export default __webpack_public_path__ + "static/media/ic-pending-validation.af7ed212ef55be9cbab3cec57bec6083.svg";
export { ForwardRef as ReactComponent };